import { Button, LoadingSpinner, TextFormField } from "@/components/ui";
import { useFormContext } from "react-hook-form";

export interface RegisterFormProps {
  onSubmit: () => Promise<void>;
  isLoading?: boolean;
}

function RegisterForm({ onSubmit, isLoading }: RegisterFormProps) {
  const form = useFormContext();

  return (
    <form
      onSubmit={form.handleSubmit(onSubmit)}
      className="mt-8 flex flex-col gap-y-4"
    >
      <TextFormField
        dataTestId="register-firm-name"
        register={form.register("firmName")}
        label="Firm name"
      />
      <TextFormField
        dataTestId="register-user-email"
        register={form.register("email")}
        label="Email"
        type="email"
      />
      <TextFormField
        dataTestId="register-user-first-name"
        register={form.register("firstName")}
        label="First name"
      />
      <TextFormField
        dataTestId="register-user-last-name"
        register={form.register("lastName")}
        label="Last name"
      />
      <TextFormField
        dataTestId="register-user-phone-number"
        register={form.register("phoneNumber")}
        label="Phone number"
        type="tel"
      />
      <div className="text-right">
        <Button
          data-testid="register-submit"
          type="submit"
          variant="foreground"
          className="mt-4 w-full"
          disabled={true}
        >
          {isLoading ? <LoadingSpinner /> : "Registration Coming Soon"}
        </Button>
      </div>
    </form>
  );
}

export { RegisterForm };
